import { Flex, Text } from "@chakra-ui/react";
import { OptionProps, Select, GroupBase, Props } from "chakra-react-select";
import {
    LoanTypeForTheTenantModel,
    useLoanTypesForTheTenant,
} from "hooks/useLoanTypesForTheTenant";

const CustomOption = ({
    data,
    innerProps,
}: OptionProps<LoanTypeForTheTenantModel>) => (
    <Flex
        {...innerProps}
        p={2}
        gap={4}
        borderRadius="md"
        _hover={{ bg: "gray.50" }}
        cursor="pointer"
        alignItems="center"
    >
        <Flex direction="column" alignItems="start">
            <Text color="gray.600">{data.title}</Text>
            <Text fontSize="sm" color="gray.500">
                {data.description}
            </Text>
        </Flex>
    </Flex>
);

interface LoanTypeSelectProps
    extends Props<
        LoanTypeForTheTenantModel,
        false,
        GroupBase<LoanTypeForTheTenantModel>
    > {
    loanType: LoanTypeForTheTenantModel | null;
    setLoanType: (loanType: LoanTypeForTheTenantModel | null) => void;
}

export const LoanTypeSelect = ({
    loanType,
    setLoanType,
    ...props
}: LoanTypeSelectProps) => {
    const { data: loanTypes, isLoading } = useLoanTypesForTheTenant();

    return (
        <Select<LoanTypeForTheTenantModel>
            options={
                loanTypes?.sort((a, b) => a.title.localeCompare(b.title)) ?? []
            }
            getOptionLabel={(b) => b.title}
            getOptionValue={(b) => b.id.toString()}
            components={{ Option: CustomOption }}
            isLoading={isLoading}
            chakraStyles={{
                placeholder: (provided) => ({
                    ...provided,
                    textAlign: "left",
                }),
                singleValue: (provided) => ({
                    ...provided,
                    textAlign: "left",
                }),
            }}
            placeholder="Select a loan type..."
            noOptionsMessage={() => "No loan types found."}
            onChange={(newValue) => setLoanType(newValue)}
            value={loanType}
            variant="primary"
            filterOption={(option, inputValue) =>
                [option.data.title, option.data.description].some((field) =>
                    field?.toLowerCase().includes(inputValue.toLowerCase())
                )
            }
            isClearable={true}
            {...props}
        />
    );
};
